import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import React from 'react';
import {
	FontAwesome,
	Entypo,
	Ionicons,
	MaterialCommunityIcons,
} from '@expo/vector-icons';
import { getIST } from '../utilities/Utility';

const InventoryCard = ({ item, navigation }) => {


	return (
		<View>
			<TouchableOpacity
				style={{
					padding: 12,
					borderRadius: 8,
					shadowColor: 'gray',
					backgroundColor: 'white',
					shadowOffset: { width: 2, height: 4 },
					elevation: 5,
					shadowOpacity: 0.26,
					margin: 3,
				}}
				onPress={() => {
					navigation.navigate('Device Activation', { inventory: item });
				}}
			>
				<View
					style={{
						flexDirection: 'row',
						alignItems: 'center',
						justifyContent: 'space-between',
						flexWrap: 'wrap',
					}}
				>
					<Text style={{ fontSize: 18, fontWeight: '500' }}>{item.name}</Text>
					<Text
						style={{
							fontSize: 16,
							color: 'black',
							fontWeight: '600',
						}}
					>
						{item.deviceStatus}
					</Text>
				</View>
				<View
					style={{
						flexDirection: 'row',
						alignItems: 'center',
						justifyContent: 'space-between',
						marginVertical: 8,
						flexWrap: 'wrap/;',
					}}
				>
					<View style={{ flexDirection: 'row', alignItems: 'center' }}>
						<FontAwesome name="barcode" size={22} color={'black'} />
						<Text
							style={{
								fontWeight: '600',
								color: 'gray',
								marginLeft: 6,
								fontSize: 14,
							}}
						>
							{item.dEVICEIMEI}
						</Text>
					</View>

					<View
						style={{
							flexDirection: 'row',
							alignItems: 'center',
							flexWrap: 'wrap',
						}}
					>
						<Ionicons name="time-outline" size={22} color={'green'} />
						<Text style={{ fontWeight: '600', color: 'gray', marginLeft: 2 }}>
							{getIST(item.createdAt)}
						</Text>
					</View>
				</View>
				<View style={{ flexDirection: 'row', alignItems: 'center' }}>
					<MaterialCommunityIcons name="sim" size={22} color={'red'} />
					<Text
						style={{
							fontWeight: '600',
							color: 'gray',
							marginLeft: 4,
							fontSize: 14,
						}}
					>
						{item.dEVICESIM}
					</Text>
				</View>
			</TouchableOpacity>
		</View>
	);
};

export default InventoryCard;

const styles = StyleSheet.create({});
